export default {
  install(app) {
    /**
     *
     * @param {string} store
     * @param {object} payload
     * @param {boolean} removeReactivity
     */
    app.config.globalProperties.$setState =
    (store, payload, removeReactivity = true) => {
      payload._removeReactivity = removeReactivity
      app.config.globalProperties.$store.commit(`${store}/setState`, payload)
    }
  }
}
